import React from 'react';
import {
    Box, Typography, Divider, useTheme, IconButton
} from '@mui/material';
import { ChevronRight } from '@mui/icons-material';

const ProfileList = ({ screens }) => {
    const theme = useTheme();

    const groupedScreens = screens?.reduce((groups, screen) => {
        const category = screen?.category || 'Other';
        if (!groups[category]) groups[category] = [];
        groups[category].push(screen);
        return groups;
    }, {});

    return (
        <>
            {groupedScreens &&
                Object.entries(groupedScreens).map(([category, items], catIndex) => (
                    <Box key={catIndex} mb={1}>
                        <Typography
                            variant="subtitle2"
                            color={theme.palette.primary.main}
                            sx={{ px: 2, opacity: 0.8, fontSize: "15px" }}
                        >
                            {category}
                        </Typography>

                        {items.map((screen, index) => (
                            <Box
                                key={index}
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    color: process.env.REACT_APP_COLOR_TEXT || 'white',
                                    py: 0.5,
                                    px: 3,
                                    cursor: screen?.onClick ? 'pointer' : 'default',
                                    '&:hover': {
                                        backgroundColor: screen?.onClick ? 'action.hover' : 'transparent',
                                    },
                                }}
                                onClick={screen?.onClick}
                            >
                                <Box
                                    display="flex"
                                    alignItems="center"
                                    justifyContent="space-between"
                                >
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                                        {screen?.icon}
                                        <Typography fontSize="11px" variant="body1">
                                            {screen?.label}
                                        </Typography>
                                    </Box>

                                    <IconButton size="small" disableRipple>
                                        <ChevronRight fontSize="small" />
                                    </IconButton>
                                </Box>

                                {index !== items.length - 1 && (
                                    <Divider sx={{ mt: 0.7, borderColor: theme.palette.divider1 }} />
                                )}
                            </Box>
                        ))}
                    </Box>
                ))}
        </>
    );
};

export default ProfileList;
